import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import { useGlobalAlert } from "../Common/Context/GlobalAlertContext";
import StickyPageLayout from "../Layout/PageLayout/StickyPageLayout";
import SupplierPartyView from "./SupplierPartyView";
import { Formik } from "formik";
import { supplierPartyInitialValues, supplierPartyValidationSchema } from "./supplierPartyFormValidationSchema";
import { handleAE_supplierPartyForm } from "./supplierPartyModel";

 
  
const SupplierPartyForm = () => {
  const navigate = useNavigate();
  const { showAlert } = useGlobalAlert();
 
  const location = useLocation();
  const [submitLoading, setSubmitLoading] = useState(false);

  const initialValues = () => {    
    const data = location.state;    

    if (data === null || data === undefined) {
      return { ...supplierPartyInitialValues,          
          };       
    }
   
    return { ...data,};
  };

  const listProps = {
    type: 'button',
    text: 'List',
    onClick: () => {navigate('/admin/sup-list')}, // 👈 important
    style: { backgroundColor: '#333', color: '#fff' }
   };
  const submitProps = {
    type: 'submit',    
    loading:submitLoading,
  };

  const handleSubmit = async(values, { resetForm }) => {
    // alert(JSON.stringify(values))
    handleAE_supplierPartyForm({
      data:values,
      showAlert,
      navigate,
      resetForm,
      setLoading:setSubmitLoading,
    })
  }

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues()}
      validationSchema={supplierPartyValidationSchema}
      onSubmit={handleSubmit}
    >
      {({ handleSubmit, ...props }) => (
        <StickyPageLayout
          title="Manage Supplier/Party"          
          submitProps={{...submitProps,
           onClick:handleSubmit,
            className:'btn-modern btn-blue'}}
          listProps={listProps}
        > 
        <SupplierPartyView {...props} />
          
        </StickyPageLayout>
        )}
    </Formik>
  );
};

export default SupplierPartyForm;